export default class Sidebar {
  initializeListeners() {
    $('.sidebar a').on('click', () => $('html').removeClass('noscroll'));
  }
}
